import type { CustomCellRendererProps } from "ag-grid-react";

import { ApplicationProcessingStateBadge } from "../../../components/application/application-status";
import { APPLICATION_PROCESSING_STATE_LABEL, getApplicationProcessingState, type ApplicationsTableItem } from "../applications-page.lib";

export const ApplicationProcessingStatusCell = ({ data }: CustomCellRendererProps<ApplicationsTableItem>) => {
  const state = getApplicationProcessingState(data);

  if (!state) {
    return <span className="text-type-minor">—</span>;
  }

  return <ApplicationProcessingStateBadge label={APPLICATION_PROCESSING_STATE_LABEL[state]} processingState={state} />;
};
